import { NgModule,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TradingViewComponent } from './trading-view.component';



@NgModule({
  declarations: [TradingViewComponent],
  imports: [
    CommonModule
  ],
  exports:[
    TradingViewComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class TradingViewModule { }
